import React from 'react';
import { colors } from 'seedling/constants';

const RatingNoDecisionIcon = ({ width = 20, height = 20, color }) => {
  return (
    <svg width={width + 'px'} height={height + 'px'} viewBox="0 0 20 20">
      <defs>
        <path
          d="M9,0.85 C13.9705627,0.85 18,4.87943725 18,9.85 C18,14.8205627 13.9705627,18.85 9,18.85 C4.02943725,18.85 0,14.8205627 0,9.85 C0,4.87943725 4.02943725,0.85 9,0.85 Z M9,2.23461538 C4.79413921,2.23461538 1.38461538,5.64413921 1.38461538,9.85 C1.38461538,14.0558608 4.79413921,17.4653846 9,17.4653846 C13.2058608,17.4653846 16.6153846,14.0558608 16.6153846,9.85 C16.6153846,5.64413921 13.2058608,2.23461538 9,2.23461538 Z M8.92814217,12.1672218 C9.47435786,12.1672218 9.91715316,12.6100171 9.91715316,13.1562328 C9.91715316,13.7024485 9.47435786,14.1452438 8.92814217,14.1452438 C8.38192648,14.1452438 7.93913118,13.7024485 7.93913118,13.1562328 C7.93913118,12.6100171 8.38192648,12.1672218 8.92814217,12.1672218 Z M8.87560096,5.23461538 C9.69050888,5.23461538 10.3674853,5.42932498 10.9065505,5.81875 C11.4456157,6.20817502 11.7151442,6.78509233 11.7151442,7.54951923 C11.7151442,8.01827157 11.5979579,8.41309936 11.3635817,8.73401442 C11.2265618,8.92872694 10.9633433,9.17752252 10.5739183,9.48040865 L10.1899038,9.77788462 C9.98076819,9.94014504 9.84194746,10.129446 9.7734375,10.3457933 C9.73016805,10.4828132 9.70673079,11.1570899 9.703125,11.4455529 L8.24278846,11.4455529 C8.26442319,10.8361748 8.26442319,10.0635944 8.41586538,9.72109375 C8.56730758,9.37859312 8.75119998,9.22079478 9.140625,8.91790865 L9.53545673,8.60961538 C9.66526507,8.51225913 9.76983133,8.40589 9.84915865,8.29050481 C9.99339014,8.09218651 10.0655048,7.87403965 10.0655048,7.63605769 C10.0655048,7.36201786 9.98527724,7.11232084 9.82481971,6.88695913 C9.66436218,6.66159743 9.37139636,6.54891827 8.94591346,6.54891827 C8.52764214,6.54891827 8.23107059,6.687739 8.0561899,6.96538462 C7.88130922,7.24303023 7.79387019,7.53148889 7.79387019,7.83076923 L6.23076923,7.83076923 C6.27403868,6.80311986 6.63280913,6.07476176 7.30709135,5.64567308 C7.73257424,5.37163325 8.25540555,5.23461538 8.87560096,5.23461538 Z"
          id="question-mark-path-1"
        />
      </defs>
      <g
        id="Icons/question"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Color/greyMedium-909090"
          transform="translate(1.000000, 0.150000)"
        >
          <mask id="question-mark-mask-2" fill="white">
            <use xlinkHref="#question-mark-path-1" />
          </mask>
          <use
            id="RatingNoDecisionMask"
            fill={color}
            xlinkHref="#question-mark-path-1"
          />
          <g mask="url(#question-mark-mask-2)" fill={color} id="color">
            <g transform="translate(-1.000000, 0.000000)">
              <rect x="0" y="0" width={width} height={color} />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

RatingNoDecisionIcon.defaultProps = {
  color: colors.mediumGrey,
  width: 20,
  height: 20,
};

export default RatingNoDecisionIcon;
